const STORAGE_KEY = '91app_auth';

// 從 JWT token 中解析過期時間
const getTokenExpiration = (token) => {
  try {
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    // JWT 的 exp 是以秒為單位的 Unix timestamp
    return payload.exp ? payload.exp * 1000 : null;
  } catch (error) {
    console.error('Failed to parse JWT token:', error);
    return null;
  }
};

const loadFromStorage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const data = JSON.parse(stored);
      return {
        accessToken: data.accessToken || null,
        jwtToken: data.jwtToken || null,
        customer: data.customer || null,
        expiresAt: data.expiresAt || null,
        isAuthenticated: !!data.jwtToken,
      };
    }
  } catch (error) {
    console.error('Failed to load 91APP auth from localStorage:', error);
  }
  return {
    accessToken: null,
    jwtToken: null,
    customer: null,
    expiresAt: null,
    isAuthenticated: false,
  };
};

const saveToStorage = (state) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      accessToken: state.accessToken,
      jwtToken: state.jwtToken,
      customer: state.customer,
      expiresAt: state.expiresAt,
    }));
  } catch (error) {
    console.error('Failed to save 91APP auth to localStorage:', error);
  }
};

export default {
  namespaced: true,
  state: loadFromStorage(),
  getters: {
    accessToken(state) {
      return state.accessToken;
    },
    jwtToken(state) {
      return state.jwtToken;
    },
    customer(state) {
      return state.customer;
    },
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    isTokenValid(state) {
      // 檢查是否已驗證且 token 未過期
      if (!state.isAuthenticated || !state.jwtToken) {
        return false;
      }
      // 如果有過期時間，檢查是否已過期
      if (state.expiresAt) {
        return Date.now() < state.expiresAt;
      }
      // 如果沒有過期時間資訊，嘗試從 token 中解析
      const expiresAt = getTokenExpiration(state.jwtToken);
      if (expiresAt) {
        return Date.now() < expiresAt;
      }
      // 如果無法獲取過期時間，保守起見認為已過期
      return false;
    },
  },
  mutations: {
    SET_ACCESS_TOKEN(state, token) {
      state.accessToken = token;
      saveToStorage(state);
    },
    SET_JWT_TOKEN(state, token) {
      state.jwtToken = token;
      state.isAuthenticated = !!token;
      state.expiresAt = getTokenExpiration(token);
      saveToStorage(state);
    },
    SET_CUSTOMER(state, customer) {
      state.customer = customer;
      saveToStorage(state);
    },
    SET_AUTH_DATA(state, { accessToken, jwtToken, customer }) {
      state.accessToken = accessToken;
      state.jwtToken = jwtToken;
      state.customer = customer;
      state.expiresAt = getTokenExpiration(jwtToken);
      state.isAuthenticated = !!jwtToken;
      saveToStorage(state);
    },
    CLEAR_AUTH(state) {
      state.accessToken = null;
      state.jwtToken = null;
      state.customer = null;
      state.expiresAt = null;
      state.isAuthenticated = false;
      localStorage.removeItem(STORAGE_KEY);
    },
  },
  actions: {
    setAuthData({ commit }, { accessToken, jwtToken, customer }) {
      commit('SET_AUTH_DATA', { accessToken, jwtToken, customer });
    },
    clearAuth({ commit }) {
      commit('CLEAR_AUTH');
    },
    setAccessToken({ commit }, token) {
      commit('SET_ACCESS_TOKEN', token);
    },
    setJwtToken({ commit }, token) {
      commit('SET_JWT_TOKEN', token);
    },
    setCustomer({ commit }, customer) {
      commit('SET_CUSTOMER', customer);
    },
  },
};